import OfflinePluginRuntime from '@lcdp/offline-plugin/runtime';

export const setupOfflinePlugin = () => {
  OfflinePluginRuntime.install();
};
